import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { useState } from "react";
import { postCourseItemLikeData, postCourseItemRegisterData } from "../services/courseService";
import image from "../stories/assets/course-item-1.svg";
import teacherImage from "../stories/assets/course-item-teacher.png";

export default function CourseItem({ courseData }) {
  const [like, setLike] = useState(false);

  const handleLikeClick = async () => {
    await postCourseItemLikeData(courseData);
    setLike((prevLike) => !prevLike);
  };

  const handleRegister = async () => {
    await postCourseItemRegisterData(courseData);
  };

  return (
    <div className="course-item">
      <div className="absolute flex align-items-center justify-content-center bg-white m-2 cursor-pointer course-item-like" onClick={handleLikeClick}>
        <i className={`pi pi-heart${like ? "-fill" : ""} font-size-15 primary-color`}></i>
      </div>
      <div style={{ height: "256px" }}>
        <img className="h-full w-full object-fit-cover" alt="course-image" src={image} />
      </div>
      <div className={`my-3 course-item-content course-item-content-${courseData?.id}`}>
        <div className="flex flex-column default-text gap-075">
          <h1 className="text-base font-bold line-height-3 m-0 course-item-title">{courseData?.courseTitle}</h1>
          <h1 className="text-xl font-bold m-0 primary-color line-height-28">{courseData?.price?.discountPrice}</h1>
          <div className="flex justify-content-between text-sm line-height-2">
            <div className="flex align-items-center ml-1">
              <i className="pi pi-book mr-2 font-size-15"></i>
              <span>{courseData?.lessonQuantity}</span>
              <span>&nbsp;</span>
              <span className="gray-color">bài học</span>
            </div>
            <div className="flex align-items-center">
              <i className="pi pi-clock mr-2 font-size-15"></i>
              <span>{courseData?.lessonTime}</span>
              <span className="gray-color">/bài học</span>
            </div>
          </div>
          <div className="flex justify-content-between text-sm line-height-2">
            <div className="flex align-items-center ml-1">
              <i className="pi pi-star-fill mr-2 font-size-15 orange-color"></i>
              <span className="font-weight-500 gray-color">{courseData?.reviewPoint}</span>
            </div>
            <div className="flex align-items-center">
              <i className="pi pi-users mr-2 font-size-15"></i>
              <span>{courseData?.studentQuantity}</span>
              <span>&nbsp;</span>
              <span className="gray-color">học viên</span>
            </div>
          </div>
        </div>
      </div>
      <Tooltip
        autoHide={false}
        target={`.course-item-content-${courseData?.id}`}
        pt={{
          text: {
            className: "custom-tooltip-text",
          },
          arrow: {
            className: "custom-tooltip-arrow",
          },
        }}
      >
        <div className="course-item-tooltip-wrapper">
          <div className="course-item-tooltip-label">
            <p className="course-item-tooltip-label-p">{courseData?.packageTitle}</p>
          </div>
          <h1 className="course-item-tooltip-title">{courseData?.courseTitle}</h1>
          <div className="flex justify-content-between align-items-center">
            <div className="flex gap-05">
              <div className="course-item-tooltip-teacher-img">
                <img alt="teacher-image" src={teacherImage} />
              </div>
              <div>
                <h4 className="font-size-14 m-0 font-weight-400 line-height-22 gray-color">Giảng Viên</h4>
                <h4 className="default-text font-size-16 m-0 font-weight-500 line-height-24">{courseData?.trainer?.name}</h4>
              </div>
            </div>
            <div className="flex align-items-center">
              <i className="pi pi-star-fill mr-2 font-size-15 orange-color"></i>
              <span className="default-text font-size-16 font-weight-500 line-height-22">{courseData?.trainer?.reviewPoint}</span>
              <span>&nbsp;</span>
              <span className="font-size-14 font-weight-400 line-height-24 gray-color">({courseData?.trainer?.reviewQuantity})</span>
            </div>
          </div>
          <div className="flex justify-content-between mt-3">
            <div className="flex align-items-center font-size-14">
              <i className="pi pi-user mr-2 font-size-15 secondary-blue-color"></i>
              <span className="default-text">{courseData?.studentQuantity}</span>
              <span>&nbsp;</span>
              <span className="gray-color">học viên</span>
            </div>
            <div className="flex align-items-center">
              <i className="pi pi-clock mr-2 font-size-15 green-color"></i>
              <span className="default-text font-size-14">{courseData?.duration}</span>
            </div>
          </div>
          <div className="flex justify-content-between mt-3 mb-3">
            <div>
              <div className="flex gap-05">
                <h4 className="default-text font-size-24 font-weight-400 line-height-32 m-0">{courseData?.price?.discountPrice}</h4>
                <div className="bg-alice-blue inline-block" style={{ padding: "4px 6px" }}>
                  <p className="font-size-14 font-weight-500 line-height-24 m-0 secondary-blue-color uppercase">{courseData?.price?.discountLabel}</p>
                </div>
              </div>
              <p className="font-size-16 font-weight-400 line-height-24 m-0 select-none line-through gray-color">{courseData?.price?.originalPrice}</p>
            </div>
            <div>
              <div className="flex align-items-center justify-content-center cursor-pointer bg-alice-blue h-3rem w-3rem" onClick={handleLikeClick}>
                <i className={`pi pi-heart${like ? "-fill" : ""} font-size-15 primary-color`}></i>
              </div>
            </div>
          </div>
        </div>
        <div className="course-item-tooltip-benefit pb-2">
          <p className="font-size-12 font-weight-500 line-height-16 text-default-text-color" style={{ margin: "1.5rem 0 0.5rem" }}>
            Bạn sẽ học những gì?
          </p>
          {courseData?.benefits?.map((item) => (
            <div className="flex align-items-start mb-2">
              <i className="pi pi-check mr-2 font-size-15 line-height-22 green-color"></i>
              <span className="font-size-14 font-weight-400 line-height-22 word-break-overflow gray-color">{item}</span>
            </div>
          ))}
        </div>
        <div className="font-size-16 gap-075 flex flex-column" style={{ padding: "1.5rem 20px 0" }}>
          <Button className="lg-btn-primary center-icon-btn justify-content-center" label="Đăng ký khoá học" icon="pi pi-shopping-cart" onClick={handleRegister} />
          <Button
            className="lg-btn-secondary"
            label="Xem chi tiết"
            onClick={() => {
              window.location.href += `/${courseData?.id}`;
            }}
          />
        </div>
      </Tooltip>
    </div>
  );
}
